import PropTypes from 'prop-types';
import React from 'react';

import * as Inputs from './index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Dispatcher = (props) => {
    if (!props?.type || typeof (Inputs[props?.type]) === 'undefined') {
        return null;
    }
    const Input = Inputs[props.type];

    return (
        <Input { ...props } />
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Dispatcher.displayName = 'FormInputDispatcher';

Dispatcher.propTypes = {
    control: PropTypes.object.isRequired,
    description: PropTypes.string,
    errors: PropTypes.object,
    id: PropTypes.string.isRequired,
    isDirty: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    register: PropTypes.func.isRequired,
    required: PropTypes.bool,
    type: PropTypes.string.isRequired
};

export default Dispatcher;
